import { VAST } from '@lib/iab/iab-vast-model';
import { DOMParser } from 'xmldom';

import parse from './parse';

export interface VASTParserOptions {
    domParser?: DOMParser;
    strict?: boolean;
    noSingleAdPods?: boolean;
}

const parseVast = (
    xml: string | Document,
    options: VASTParserOptions = {}
): VAST => {
    if (options.domParser == null) {
        options.domParser = new DOMParser();
    }
    return parse(xml, options);
};

export default parseVast;
